
export class AdHocData {

  //common methods
  resetToDefaults = () => {
    return;
  };
  updateTactic = () => {
    return;
  };
  validate = () => {
    return [true, ''];
  };
  returnJson = () => {
    return {
    };
  };
}
